import userSaga from './userSaga'
import onboardingSaga from './onboardingSaga'
import saversSaga from './saversSaga'
import transfersSaga from './transfersSaga'
import cashoutSaga from "./cashoutSaga"
import fundSaga from "./fundSaga"
import SettingsSaga from "./settingsSaga"
import CommissionSaga from "./commissionSaga"
import AgentsSaga from "./agentsSaga"
import paymentsSaga from "./paymentsSaga"



import {all} from 'redux-saga/effects'


export default function* rootSaga() {
  yield all([
    ...userSaga,
    ...onboardingSaga,
    ...saversSaga,
    ...transfersSaga,
    ...cashoutSaga,
    ...fundSaga,
    ...SettingsSaga,
    ...CommissionSaga,
    ...AgentsSaga,
    ...paymentsSaga
  ])
}
